<template>
  <div class="wrapper">
    <div class="yyscess">
      <span><img src="@/assets/payment/succeed.png" /><span>预约成功</span></span>
      <span>（请在&nbsp;<van-count-down :time="time" format="mm:ss" />&nbsp;内完成支付，否则将<span style="color: #CD2626;">自动取消预约</span>）</span>
    </div>
    <div class="price">
      <span>￥</span>
      <span style="margin-left: 10px;">{{ (Math.round(orderObj.fee*100)/100).toFixed(2) }}</span>
    </div>
    <ul class="deta_list">
      <li>
        <span>【预约院区】</span>
        <span>{{ orderObj.deptname }}</span>
      </li>
      <li>
        <span>【预约科室】</span>
        <span>{{ orderObj.parentdeptname }}</span>
      </li>
      <li>
        <span>【预约医生】</span>
        <span>{{ orderObj.doctor }}</span>
      </li>
      <li>
        <span>【预约日期】</span>
        <span>{{ orderObj.visitingday }}</span>
      </li>
      <li>
        <span>【预约时间段】</span>
        <span>{{ orderObj.visitingtime }}</span>
      </li>
    </ul>
    <div class="yygh" @click="payment2">
      <van-button type="info">立即支付</van-button>
    </div>
  </div>
</template>

<script>
import { appointmentCountDown, pay, getRegRecordDetail } from "@/request/api.js";
import { throttle, debounce } from "@/tool/shake.js";
export default {
  data() {
    return {
      orderObj: {},
      time: 15 * 60 * 1000,
    }
  },
  created() {
    this.payment2 = debounce(this.payment,400);
    this.getOrder();
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // if(from.path = "/countDown"){
      //   this.$router.push("/mySubscribe")
      // }
    })
  },
  methods: {
    async getdjs(){
      let res = await appointmentCountDown(this.orderObj.lockid)
      this.time = (res.data.obj)*1000
    },
    async getOrder(){
      let res = await getRegRecordDetail(sessionStorage.getItem("orderId"));
      if(res.data.message == "操作成功"){
        this.orderObj = res.data.obj
        this.getdjs();
      }
    },
    async payment(){
      let map = {
        flag: 1, // 1=挂号缴费 2=门诊缴费 3=住院充值
        payTypeId: 1,
        orderDate: this.orderObj.regtime.slice(0,10),
        orderTime: this.$moment().format("HH:mm:ss"),
        orderTimeoutDate: "",
        orderNo: this.orderObj.lockid,
        currencyCode: 156,
        // orderAmount: 0.01,
        orderAmount: this.orderObj.regAmount,
        payInDepositOrderPo: {}, // 入住院缴费实体
        payOpChargePo: {}, // 门诊缴费实体
        subsidAmount: "",
        expireDate: "",
        accountNo: "",
        openID: this.orderObj.openid,
        orderDesc: "医院公众号预约挂号",
        receiverAddress: "",
        buyIp: ""
      }
      let rs = await pay(map);
      let that = this;
      function onBridgeReady() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: rs.data.obj.sub_appId,
            timeStamp: rs.data.obj.timeStamp,
            nonceStr: rs.data.obj.nonceStr,
            signType: rs.data.obj.signType,
            paySign: rs.data.obj.paySign,
            package: rs.data.obj.package,
          },
          function (obj) {
            if (obj.err_msg == "get_brand_wcpay_request:ok") {
              if (res.data.message == "操作成功") {
                that.Toast.success("支付成功,即将返回预约页面");
                setTimeout(() => {
                  // that.$router.push("/home");
                  that.$router.go(-1);
                }, 1500);
              } else if (obj.err_msg == "get_brand_wcpay_request:cancel") {
              } else {
              }
            }
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    },
  },
}
</script>


<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F8F8F8;
  .yyscess{
    padding: 30px 0px;
    background: #fff;
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    border-bottom: 1px solid rgb(229, 229, 229);
    >span:nth-child(1){
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      font-size: 16px;
      letter-spacing: 1px;
      margin-bottom: 10px;
      span{
        font-weight: bold;
        position: relative;
        top: 2px;
        left: 4px;
      }
    }
    >span:nth-child(2){
      .van-count-down{
        color: rgb(255, 217, 0);
        display: inline-block;
      }
    }
  }
  .price{
    // margin-top: 10px;
    padding-top: 10px;
    text-align: center;
    font-size: 40px;
    background: #fff;
    position: relative;
    >span:nth-child(1){
      position: relative;
      left: 16px;
    }
  }
  .deta_list{
    padding: 30px 28px 14px;
    background: #fff;
    font-size: 15px;
    display: flex;
    flex-flow: column nowrap;
    >li{
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      margin-bottom: 14px;
      >span:nth-child(1){
        font-weight: bold;
      }
      >span:nth-child(2){
        color: #8B8B8B;
      }
    }
  }
  /deep/ .yygh{
    position: absolute;
    width: 355px;
    bottom: 40px;
    text-align: center;
    margin: 0px 10px;
    background: rgb(83, 192, 255);
    color: rgb(255, 255, 255);
    .van-button{
      background: rgb(83, 192, 255);
      padding: 24px 0px;
      width: 355px;
      letter-spacing: 1px;
      font-size: 20px;
      border-color: rgb(62, 184, 255);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/countDown.vue